<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<nav class="navbar_position z-3">
  <div class="d-flex gap-4" style="background:#FFF;border-bottom: 2.3px solid #005C8A;border-radius: 4%;">
    <!-- justify-content-between -->
    <div class="d-flex w-100 px3 " *ngIf="!qmsservice.showTopNav">
      <div class="d-flex dropdown" style="align-items: center;">
        <div class="main-logo-container">
          <span *ngIf="oneQmsOrgImagesDetails != null || oneQmsOrgImagesDetails != undefined">
            <img *ngIf="oneQmsOrgImagesDetails.logoImage" class="org-image"
              [class.square-image]="oneQmsOrgImagesDetails.isLogoImageSquare === 'Y'"
              src="data:image/*;base64,{{oneQmsOrgImagesDetails.logoImage}}" alt="logo">
          </span>
          <span *ngIf="oneQmsOrgImagesDetails == null || oneQmsOrgImagesDetails == undefined">
            <i class="org-image"></i>
          </span>
          <div *ngIf="orgDetail!={}" class="px-2" style="color: #0F3659;font-size:26px;font-weight: 600;">
            {{orgDetail.applicationName}}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 navbar_shadow p-1" *ngIf="qmsservice.showTopNav && qmsservice.topNavModule == 'Quality'">
      <div class="d-flex align-items-center position-relative">
        <div class="d-flex" style="margin-left: 1%;border-right: solid 1px #cfcfcf;cursor: pointer;"
          *ngFor="let primarySelectorAtUIPage of message.primarySelectorAtUIPageList">
          <div class="d-flex px-2 dropdown" *ngIf="primarySelectorAtUIPage=='Group'" title="Group">
            <img _ngcontent-ng-c1030985126="" src="../../assets/img/people.png" alt="Customer Complaint" width="20"
              height="20" class="ng-star-inserted">
            <button class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" style="margin-top: -3%"
              type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{qmsservice.SelectedGroupNameAndValue[0]?.displayExp}} &nbsp;
              <i class="fa-solid fa-chevron-down"></i>
            </button>
            <ul class="dropdown-menu px-3 border-0 dropdown_items scroll">
              <li *ngFor="let item of groupValueDropdown" class="d-flex align-items-center pt-2"
                style="border-top: 1px solid #cfcfcf;">
                <img _ngcontent-ng-c1030985126="" src="../../assets/img/people.png" alt="Customer Complaint" width="20"
                  height="20" class="ng-star-inserted">
                <a class="dropdown-item px-3 dropdown_text" (click)="newgroupSelet(item,'groupClicked')">
                  {{item.displayExp}}</a>
              </li>
            </ul>
          </div>
          <div class="d-flex px-1 dropdown" *ngIf="primarySelectorAtUIPage=='Module'" title="Module">
            <div *ngIf="qmsservice.moduleName=='CR'">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
                  stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </div>
            <div *ngIf="qmsservice.moduleName=='CAPA'">
              <img class="svg_dimension" src="../../assets/img/CAPA.svg" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='DV'">
              <img class="svg_dimension" src="../../assets/img/Deviations.svg" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='AU'">
              <img lass="svg_dimension" src="../../assets/img/Audit_cr.svg" alt="" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='QI'">
              <img class="svg_dimension" src="../../assets/img/Quality Issues.svg" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='CC'">
              <img class="svg_dimension" src="../../assets/img/Customer Complaints.svg" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='IN'">
              <img class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
            </div>
            <div *ngIf="qmsservice.moduleName=='OOS'">
              <img class="svg_dimension" src="../../assets/img/specification.png" alt="" />
            </div>
            <button class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button"
              style="margin-top: -3%" data-bs-toggle="dropdown" aria-expanded="false">
              {{qmsservice.moduleFullName}} &nbsp;
              <i class="fa-solid fa-chevron-down"></i>
            </button>
            <ul class="dropdown-menu px-3 border-0 dropdown_items">
              <li *ngFor="let item of qmsservice.userModuleList" class="d-flex align-items-center pt-2"
                style="border-top: 1px solid #cfcfcf;">
                <div *ngIf="item.module=='CR'">
                  <svg width="24" height="25" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
                      stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </div>
                <div *ngIf="item.module=='CAPA'">
                  <img class="svg_dimension" src="../../assets/img/CAPA.svg" alt="" />
                </div>
                <div *ngIf="item.module=='DV'">
                  <img class="svg_dimension" src="../../assets/img/Deviations.svg" alt="" />
                </div>
                <div *ngIf="item.module=='AU'">
                  <img lass="svg_dimension" src="../../assets/img/Audit_cr.svg" alt="" alt="" />
                </div>
                <div *ngIf="item.module=='QI'">
                  <img class="svg_dimension" src="../../assets/img/Quality Issues.svg" alt="" />
                </div>
                <div *ngIf="item.module=='CC'">
                  <img class="svg_dimension" src="../../assets/img/Customer Complaints.svg" alt="" />
                </div>
                <div *ngIf="item.module=='IN'">
                  <img class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
                </div>
                <div *ngIf="item.module=='OOS'">
                  <img class="svg_dimension" src="../../assets/img/specification.png" alt="" />
                </div>
                <div *ngIf="item.module=='DA'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g>
                      <g>
                        <path
                          d="M16.2222 1.99998C17.2041 1.99998 18 2.78502 18 3.75341L18 6.74659C18 7.71498 17.2041 8.50001 16.2222 8.50001H13.5556C12.5737 8.50001 11.7778 7.71498 11.7778 6.74659L11.7778 3.75341C11.7778 2.78502 12.5737 1.99998 13.5556 1.99998L16.2222 1.99998Z"
                          stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M3.77778 1.99998C2.79594 1.99998 2 2.78502 2 3.75341L2.00001 6.74659C2.00001 7.71498 2.79595 8.50001 3.77778 8.50001H6.44445C7.42629 8.50001 8.22223 7.71498 8.22223 6.74659L8.22222 3.75341C8.22222 2.78502 7.42628 1.99998 6.44444 1.99998L3.77778 1.99998Z"
                          stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M16.2222 11.5C17.2041 11.5 18 12.285 18 13.2534V16.2466C18 17.215 17.2041 18 16.2222 18H13.5556C12.5737 18 11.7778 17.215 11.7778 16.2466L11.7778 13.2534C11.7778 12.285 12.5737 11.5 13.5556 11.5H16.2222Z"
                          stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M3.77778 11.5C2.79594 11.5 2.00001 12.285 2.00001 13.2534L2.00001 16.2466C2.00001 17.215 2.79595 18 3.77779 18H6.44445C7.42629 18 8.22223 17.215 8.22223 16.2466L8.22223 13.2534C8.22223 12.285 7.42629 11.5 6.44445 11.5H3.77778Z"
                          stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                    </g>
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text" (click)="newmoduleSelect(item,'moduleClicked')">
                  {{item.moduleName}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown d-flex px-2 pt-2" style="margin-top: -2%;cursor: pointer;line-height: 23px;"
          *ngIf="qmsservice.showGridSection">
          <div (click)="newredirect()" (keydown.enter)="newredirect()">
            <svg width="22" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.2998 22.347H5.49978C4.1743 22.347 3.09978 21.2725 3.09979 19.947L3.09989 5.54708C3.09989 4.2216 4.17441 3.14709 5.49989 3.14709H16.3002C17.6256 3.14709 18.7002 4.22161 18.7002 5.54709V12.1471M7.30017 7.94709H14.5002M7.30017 11.5471H12"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.588 19.8546L11.5991 19.3816L11.1666 19.5733C10.9949 19.6494 10.8098 19.6842 10.6274 19.673L10.6274 19.673L10.6239 19.6728C10.2997 19.6567 10.0057 19.5153 9.79258 19.2727L9.79084 19.2707C9.57624 19.0307 9.46827 18.7199 9.48675 18.3911C9.52702 17.7168 10.1057 17.1979 10.7711 17.2324C10.9312 17.2423 11.0816 17.2811 11.2178 17.3462L11.6363 17.5463L11.6471 17.0826L11.712 14.319L13.5874 14.3519L14.0263 14.3596L13.8741 13.9479C13.8216 13.806 13.7956 13.6542 13.7988 13.4974C13.8145 12.8264 14.375 12.2862 15.0467 12.2952C15.7136 12.3076 16.2425 12.8583 16.2266 13.5308C16.2206 13.6872 16.1871 13.8402 16.1281 13.9802L15.9559 14.3891L16.3996 14.3966L19.1929 14.4436L19.1215 17.3767C18.9089 17.2342 18.6616 17.1511 18.4032 17.1377L18.4029 17.1377C17.6098 17.0971 16.9287 17.7103 16.8807 18.507L16.8806 18.5074C16.8578 18.8946 16.9891 19.2646 17.2415 19.5503L17.2424 19.5513C17.4991 19.8393 17.8519 20.0104 18.2378 20.0306L18.2378 20.0306L18.2409 20.0307C18.5348 20.0431 18.8228 19.9685 19.0702 19.8151L19.0175 21.9649L16.0387 21.9139C16.1785 21.6922 16.2603 21.4356 16.2677 21.1703C16.2799 20.7815 16.135 20.4145 15.8675 20.137C15.6028 19.8605 15.2442 19.7037 14.8608 19.6943L14.8608 19.6943L14.859 19.6942C14.0638 19.6794 13.4015 20.3175 13.3809 21.1134C13.3735 21.3806 13.443 21.6416 13.573 21.8699L11.5417 21.835L11.588 19.8546Z"
                stroke="#005C8A" stroke-width="0.6" />
            </svg>
          </div>
          <a [ngStyle]="{ 'text-decoration': (qmsservice.highlightgridsection=='Module'?'underline 11px':'none'),'min-width':'auto'}"
            class="pt-2 dropdown-item px-1 dropdown_text" (click)="newredirect()">Manage</a>
          <span *ngIf="qmsservice.highlightgridsection=='Module'" class="pt-1 px-2" matTooltip="Tag to Home"
            (click)="openTag('Module')" (keydown.enter)="openTag('Module')">
            <img src="../../../assets/img/black-tag.png" width="17px" height="19px" alt="" />
          </span>
        </div>
        <div class="dropdown d-flex px-2 pt-2" style="margin-top: -2%;cursor: pointer;line-height: 23px;"
          *ngIf="qmsservice.showReportSection" (click)="reportModuleMethod(qmsservice.moduleName)"
          (keydown.enter)="reportModuleMethod(qmsservice.moduleName)">
          <div> <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.0002 3.14709V6.74709C15.0002 7.40984 15.5375 7.94709 16.2002 7.94709H19.8002M8.4002 18.7471V13.9471M12.0002 18.7471L12.0002 9.14709M15.6002 18.7471V13.9471M18.0002 4.94709C17.4661 4.46924 16.9119 3.90247 16.5621 3.53437C16.3292 3.28943 16.0076 3.14709 15.6696 3.14709H6.59992C5.27444 3.14709 4.19993 4.2216 4.19992 5.54708L4.19983 19.947C4.19982 21.2725 5.27433 22.347 6.59982 22.347L17.3999 22.3471C18.7253 22.3471 19.7998 21.2726 19.7999 19.9471L19.8002 7.22493C19.8002 6.91809 19.6831 6.62313 19.4702 6.40223C19.0764 5.99374 18.4188 5.32161 18.0002 4.94709Z"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
            </svg></div>
          <a [ngStyle]="{ 'text-decoration': (qmsservice.highlightgridsection=='Report'?'underline 11px':'none'),'min-width':'auto'}"
            class="pt-2 dropdown-item px-1 dropdown_text">Report</a>
          <span *ngIf="qmsservice.highlightgridsection=='Report'" class="pt-1 px-2" matTooltip="Tag to Home"
            (click)="openTag('Report')" (keydown.enter)="openTag('Report')">
            <img src="../../../assets/img/black-tag.png" width="17px" height="19px" alt="" />
          </span>
        </div>
        <div *ngIf="getVendorMenu()" class="dropdown d-flex px-2 pt-2"
          style="margin-top: -2.5%;cursor: pointer;line-height: 23px;" (click)="vendorNavigate()"
          (keydown.enter)="vendorNavigate()">
          <div class="mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M15.6 9.0891C15.6 11.0773 13.9882 12.6891 12 12.6891C10.0118 12.6891 8.40002 11.0773 8.40002 9.0891M4.7273 21.6891H19.2728C20.5581 21.6891 21.6 20.6665 21.6 19.4051L20.1091 6.08907C20.1091 4.82764 19.0672 3.80505 17.7818 3.80505H5.9273C4.64198 3.80505 3.60002 4.82764 3.60002 6.08907L2.40002 19.4051C2.40002 20.6665 3.44198 21.6891 4.7273 21.6891Z"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <a [ngStyle]="{ 'text-decoration': (qmsservice.highlightgridsection=='Vendor'?'underline 11px':'none'),'line-height': (qmsservice.highlightgridsection=='Report'?'23px':'')}"
            class="pt-2 dropdown-item px-1 dropdown_text">Vendor</a>
          <div></div>
        </div>
        <div *ngIf="getAuditMasterMenu()" class="dropdown d-flex px-2 pt-2"
          style="margin-top: -2.5%;cursor: pointer;line-height: 23px;" (click)="MasterNavigate()"
          (keydown.enter)="MasterNavigate()">
          <div class="mt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M15.6 9.0891C15.6 11.0773 13.9882 12.6891 12 12.6891C10.0118 12.6891 8.40002 11.0773 8.40002 9.0891M4.7273 21.6891H19.2728C20.5581 21.6891 21.6 20.6665 21.6 19.4051L20.1091 6.08907C20.1091 4.82764 19.0672 3.80505 17.7818 3.80505H5.9273C4.64198 3.80505 3.60002 4.82764 3.60002 6.08907L2.40002 19.4051C2.40002 20.6665 3.44198 21.6891 4.7273 21.6891Z"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <a [ngStyle]="{ 'text-decoration': (qmsservice.highlightgridsection=='AUMaster'?'underline 11px':'none'),'line-height': (qmsservice.highlightgridsection=='Report'?'23px':'')}"
            class="pt-2 dropdown-item px-1 dropdown_text">Audit Master</a>
          <div></div>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 navbar_shadow p-1" *ngIf="qmsservice.showTopNav && qmsservice.topNavModule == 'Trainings'">
      <div class="d-flex align-items-center position-relative" *ngFor="let usermodule of qmsservice.userModuleList"
        style="margin-left: 2%;">
        <div *ngIf="usermodule.icon">
          <img class="svg_dimension" src="../../assets/img/{{usermodule.icon}}.svg" alt="" />
        </div>
        <div class="dropdown">
          <button [hidden]="usermodule.name != 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{usermodule.name}}
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <button [hidden]="usermodule.name == 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button">
            {{usermodule.name}}
          </button>
          <ul class="dropdown-menu px-3 border-0 dropdown_items">
            <li *ngFor="let children of usermodule.children" class="d-flex align-items-center"
              (click)="getInsideSubMenu(children,usermodule.name)"
              (keydown.enter)="getInsideSubMenu(children,usermodule.name)">
              <div *ngIf="children.name=='Manage'">
                <img class="svg_dimension" src="../../assets/img/Tab - Files.png" alt="" />
              </div>
              <div *ngIf="children.name=='Review'">
                <img class="svg_dimension" src="../../assets/img/Review.png" alt="" />
              </div>
              <a class="dropdown-item px-2 dropdown_text">{{children.name}}</a>
            </li>

          </ul>
          <div class="mx-2" [class.highlighted_item]="usermodule.name === topNavService.selectedVal">
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 navbar_shadow p-1" *ngIf="qmsservice.showTopNav && qmsservice.topNavModule == 'Documents'">
      <div class="d-flex align-items-center position-relative" *ngFor="let usermodule of qmsservice.userModuleList"
        style="margin-left: 2%;">
        <div *ngIf="usermodule.icon">
          <img class="svg_dimension" src="../../assets/img/{{usermodule.icon}}.svg" alt="" />
        </div>
        <div class="dropdown">
          <button [hidden]="usermodule.name != 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{usermodule.name}}
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <button [hidden]="usermodule.name == 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button">
            {{usermodule.name}}
          </button>
          <ul class="dropdown-menu px-3 border-0 dropdown_items">
            <li *ngFor="let children of usermodule.children" class="d-flex align-items-center"
              (click)="getInsideSubMenu(children,usermodule.name)"
              (keydown.enter)="getInsideSubMenu(children,usermodule.name)">
              <div *ngIf="children.name=='Manage'">
                <img class="svg_dimension" src="../../assets/img/Tab - Files.png" alt="" />
              </div>
              <div *ngIf="children.name=='Review'">
                <img class="svg_dimension" src="../../assets/img/Review.png" alt="" />
              </div>
              <a class="dropdown-item px-2 dropdown_text">{{children.name}}</a>
            </li>
          </ul>
          <div class="mx-2" [class.highlighted_item]="usermodule.name === topNavService.selectedVal">
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 navbar_shadow p-1" *ngIf="qmsservice.showTopNav && qmsservice.topNavModule == 'Logs'">
      <div class="d-flex align-items-center position-relative" *ngFor="let usermodule of qmsservice.userModuleList"
        style="margin-left: 2%;">
        <div *ngIf="usermodule.icon">
          <img class="svg_dimension" src="../../assets/img/{{usermodule.icon}}.svg" alt="" />
        </div>
        <div class="dropdown">
          <button [hidden]="usermodule.name != 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{usermodule.name}}
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <button [hidden]="usermodule.name == 'User Trainings'" (click)="redirectPage(usermodule)"
            class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button">
            {{usermodule.name}}
          </button>
          <ul class="dropdown-menu px-3 border-0 dropdown_items">
            <li *ngFor="let children of usermodule.children" class="d-flex align-items-center"
              (click)="getInsideSubMenu(children,usermodule.name)"
              (keydown.enter)="getInsideSubMenu(children,usermodule.name)">
              <div *ngIf="children.name=='Manage'">
                <img class="svg_dimension" src="../../assets/img/Tab - Files.png" alt="" />
              </div>
              <div *ngIf="children.name=='Review'">
                <img class="svg_dimension" src="../../assets/img/Review.png" alt="" />
              </div>
              <a class="dropdown-item px-2 dropdown_text">{{children.name}}</a>
            </li>

          </ul>
        </div>

        <div [class.highlighted_item]="usermodule.name === topNavService.selectedVal">
        </div>

      </div>
    </div>
    <div class="d-flex w-100 navbar_shadow p-1"
      *ngIf="qmsservice.showTopNav && qmsservice.topNavModule == 'Business Process'">
      <div class="d-flex w-100 navbar_shadow p-1" *ngIf="router.url.includes('/businessArea/manage')">
        <div class="d-flex align-items-center position-relative" *ngFor="let usermodule of qmsservice.userModuleList"
          style="margin-left: 2%;">
          <div *ngIf="usermodule.icon">
            <img class="svg_dimension" src="../../assets/img/{{usermodule.icon}}.svg" alt="" />
          </div>
          <div class="dropdown">
            <button (click)="redirectPage(usermodule)"
              class="btn menu_item active border-0 outline-0 dropdown-toggle px-2" type="button">
              {{usermodule.name}}
            </button>
          </div>

          <div [class.highlighted_item]="usermodule.name === topNavService.selectedVal">
          </div>

        </div>
      </div>

      <div class="d-flex justify-content-between form_title"
        *ngIf="router.url.includes('/businessArea/executions') || router.url.includes('/businessArea/fromdetailswq')">
        <div class="d-flex" style="font-size: 13px;">
          <div style="margin: 0;flex-direction: column;" class="d-flex">
            <div class="d-flex">
              <span>
                {{message.businessProcess.setUpName}}
              </span>
              <div *ngIf="router.url.includes('/businessArea/fromdetailswq')" class="d-flex">

                <mat-icon style="font-size: 22px;">chevron_right</mat-icon>

                <span>
                  {{message.businessProcess.EXECUTION_NO}} <span style="font-size: 14px;">(Status :
                    {{message.businessProcess.status}})</span>
                </span>
              </div>
            </div>

            <div style="font-size: 12px;" *ngIf="message.businessProcess.workflowname != null">

              <div style="height: 40%;">
                <span style="font-size: 13px;font-weight: 500;">Work Flow : </span>
                {{message.businessProcess.workflowname}}&nbsp;&nbsp;
                <span style="font-size: 13px;font-weight: 500;"> WorkFlow Stage : </span>
                {{message.businessProcess.workflowStageName}}

              </div>



            </div>


          </div>

        </div>

        <div>
          <div class="button-continer" mat-dialog-actions *ngIf="router.url.includes('/businessArea/fromdetailswq')">

            <app-common-dynamic-button [data]="message.businessProcessObj"></app-common-dynamic-button>
          </div>
        </div>
      </div>
    </div>
    <div class=" navbar_shadow p-1 h-75" style="width:550px;">
      <div class="d-flex justify-content-end">
        <div class="d-flex">
          <div class="me-2 col-sm-2" style="cursor: default;">
            <span
              *ngIf="qmsservice.getOneQmsOrgUsersDetails == null || qmsservice.getOneQmsOrgUsersDetails == undefined">
              <i class="fa-regular fa-circle-user userimg" style="padding: 2px;"></i>
            </span>
            <span
              *ngIf="qmsservice.getOneQmsOrgUsersDetails != null || qmsservice.getOneQmsOrgUsersDetails != undefined">
              <img class="userimg" src="data:image/*;base64,{{qmsservice.getOneQmsOrgUsersDetails.userImage}}"
                alt="user" />
            </span>
          </div>
          <div class="dropdown col-sm-10">
            <button *ngIf="orgDetail1!=null&&orgDetail1!=undefined"
              style="margin-left: -4px;text-align: start;padding-bottom: 0px;"
              class="btn border-0 outline-0 dropdown-toggle px-1 usernameclass" type="button" data-bs-toggle="dropdown"
              aria-expanded="false" title="{{orgDetail1.userNameAtApplication}}">
              <!-- {{orgDetail1.firstName}}, {{orgDetail1.lastName}} ({{orgDetail1.userName}}) -->{{orgDetail1.userNameAtApplication}}
              <i class="fa-solid fa-chevron-down"></i>
            </button>

            <ul class="dropdown-menu px-3 border-0 dropdown_items dropdownStyle" style="width: 215px;">
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="homepage()" (keydown.enter)="homepage()">
                <div>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M7.33333 18V11.9136C7.33333 11.3534 7.8109 10.8992 8.4 10.8992H11.6C12.1891 10.8992 12.6667 11.3534 12.6667 11.9136V18M9.38184 2.18771L2.44851 6.87647C2.16713 7.06676 2 7.3748 2 7.70316V16.4784C2 17.3188 2.71634 18 3.6 18H16.4C17.2837 18 18 17.3188 18 16.4784V7.70316C18 7.3748 17.8329 7.06676 17.5515 6.87647L10.6182 2.18771C10.2481 1.93743 9.75193 1.93743 9.38184 2.18771Z"
                      stroke='#0F3659' stroke-width="2" stroke-linecap="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Home</a>
              </li>
              <li *ngIf="message.isTopicAdministrator" class="d-flex align-items-center  pt-1 pb-1"
                (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()">
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M19.4667 9.86693V5.06693C19.4667 3.88872 18.5115 2.93359 17.3333 2.93359H4.53333C3.35512 2.93359 2.39999 3.88872 2.39999 5.06693V13.4148C2.39999 14.593 3.35512 15.5481 4.53333 15.5481H6.20289V20.0003L10.6551 15.5481H10.9333M16.4406 18.2843L19.2232 21.0669V18.2843H19.4667C20.6449 18.2843 21.6 17.3292 21.6 16.151V12.5336C21.6 11.3554 20.6449 10.4003 19.4667 10.4003H13.0667C11.8885 10.4003 10.9333 11.3554 10.9333 12.5336V16.151C10.9333 17.3292 11.8885 18.2843 13.0667 18.2843H16.4406Z"
                      stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Communications</a>
              </li>
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="logmethod()" (keydown.enter)="logmethod()">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20.519 12.0004C20.519 17.3023 16.2198 21.6004 10.9165 21.6004C5.61318 21.6004 1.314 17.3023 1.314 12.0004C1.314 6.69846 5.61318 2.40039 10.9165 2.40039C14.4708 2.40039 17.574 4.33094 19.2343 7.20039M17.8847 13.0539L20.2854 10.6539L22.686 13.0539M14.514 14.6181L10.914 13.4181V8.40039"
                      stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">History</a>
              </li>
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="openUserGuide()"
                (keydown.enter)="openUserGuide()">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M11.999 16.8004V16.8426M9.59999 9.04572C9.59999 7.6952 10.6745 6.60039 12 6.60039C13.3255 6.60039 14.4 7.6952 14.4 9.04572C14.4 10.3962 13.3255 11.491 12 11.491C12 11.491 11.999 12.2209 11.999 13.1213M21.6 12.0004C21.6 17.3023 17.3019 21.6004 12 21.6004C6.69806 21.6004 2.39999 17.3023 2.39999 12.0004C2.39999 6.69846 6.69806 2.40039 12 2.40039C17.3019 2.40039 21.6 6.69846 21.6 12.0004Z"
                      stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Help</a>
              </li>
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="openCustomUserGuide()"
                (keydown.enter)="openCustomUserGuide()" *ngIf="showCustomUserGuide">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M11.999 16.8004V16.8426M9.59999 9.04572C9.59999 7.6952 10.6745 6.60039 12 6.60039C13.3255 6.60039 14.4 7.6952 14.4 9.04572C14.4 10.3962 13.3255 11.491 12 11.491C12 11.491 11.999 12.2209 11.999 13.1213M21.6 12.0004C21.6 17.3023 17.3019 21.6004 12 21.6004C6.69806 21.6004 2.39999 17.3023 2.39999 12.0004C2.39999 6.69846 6.69806 2.40039 12 2.40039C17.3019 2.40039 21.6 6.69846 21.6 12.0004Z"
                      stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Custom Help</a>
              </li>
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="clearcache()" (keydown.enter)="clearcache()">
                <div>
                  <i class="fa-solid fa-broom"></i>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Clear Cache</a>
              </li>
              <li class="d-flex align-items-center  pt-1 pb-1" (click)="logout()" (keydown.enter)="logout()">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M14.6471 7.79961V5.69961C14.6471 5.14265 14.424 4.60851 14.0268 4.21469C13.6297 3.82086 13.091 3.59961 12.5294 3.59961H5.11765C4.55601 3.59961 4.01738 3.82086 3.62024 4.21469C3.22311 4.60851 3 5.14265 3 5.69961V18.2996C3 18.8566 3.22311 19.3907 3.62024 19.7845C4.01738 20.1784 4.55601 20.3996 5.11765 20.3996H12.5294C13.091 20.3996 13.6297 20.1784 14.0268 19.7845C14.424 19.3907 14.6471 18.8566 14.6471 18.2996V16.1996M8.29412 11.9996H21M21 11.9996L17.8235 8.84961M21 11.9996L17.8235 15.1496"
                      stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <a class="dropdown-item px-3 dropdown_text">Logout</a>
              </li>
            </ul>
            <div class="d-flex">
              <span class="loggedClass">
                <span id="dateTime" class="text-uppercase"></span>
                <span title="{{timezone}}">&nbsp;({{timezone}})</span>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</nav>
<ng-template #groupPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelGroupSelected()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div style="margin: 22px; height: 87px !important;">
    <div class="row align-items-center">
      <div class="col-md-2">
        <label for="email">Group</label>
        <span class="mandatory-symbol">*</span>
      </div>
      <div class="col-md-10">
        <ng-multiselect-dropdown class="multiselect-container"
          style="position: absolute;width: 74.5%; margin-top: -3%; margin-left: -3%;" [(ngModel)]="selectedGroupValue"
          [settings]="singleSelectDropdownSetting" [data]="groupValueDropdown" (onSelect)="onSelectedGroup($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <br><br>
    <div class="row align-items-center">
      <div class="col-md-2">
        <label for="email">Module</label>
        <span class="mandatory-symbol">*</span>
      </div>
      <div class="col-md-10">
        <ng-multiselect-dropdown class="multiselect-container"
          style="position: absolute;width: 74.5%; margin-top: -3%; margin-left: -3%;"
          [(ngModel)]="tempselectedModuleName1" [settings]="singleSelectDropdownSetting1" [data]="tempuserModuleList"
          (onSelect)="onSelectedmodule($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
  </div>

  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton"
      (click)="groupSelection(tempselectedModuleName12=='AU'?'AU':null,true)">
      Ok </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelGroupSelected()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #newgroupPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelnewGrouppopupSelected()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title><label for="title" class="popupTitle"> {{ popupTitle }}</label></div>
  <div class="d-flex row">
    <div class="d-flex" style="margin-left: 2%;margin-top: 2%;border: solid 1px #cfcfcf;cursor: pointer;width:95%"
      *ngFor="let primarySelectorAtUIPage of message.primarySelectorAtUIPageList">
      <div class="d-flex p-1 dropdown" *ngIf="primarySelectorAtUIPage=='Group'" title="Group">
        <img _ngcontent-ng-c1030985126="" src="../../assets/img/people.png" alt="Customer Complaint" width="20"
          height="20" class="ng-star-inserted">&nbsp;&nbsp;:
        <button class="btn menu_item active border-0 outline-0 dropdown-toggle px-2"
          style="min-width:150px;font-size: small;" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{defaultgroup?.displayExp}} &nbsp;
          <i class="fa-solid fa-chevron-down"></i>
        </button>

        <ul class="dropdown-menu px-3 border-0 dropdown_items gdrop"
          style="min-width:400px;max-height:600px; overflow-y: auto;">
          <li *ngFor="let item of groupValueDropdown" class="d-flex align-items-center pt-2"
            style="border-top: 1px solid #cfcfcf;">
            <img _ngcontent-ng-c1030985126="" src="../../assets/img/people.png" alt="Customer Complaint" width="20"
              height="20" class="ng-star-inserted">
            <a class="dropdown-item px-3 dropdown_text" (click)="newgroupSelet(item,'popupClicked')">
              {{item.displayExp}}</a>
          </li>
        </ul>
      </div>

      <div class="d-flex p-2 dropdown" *ngIf="primarySelectorAtUIPage=='Module'" title="Module">
        <div *ngIf="qmsservice.moduleName=='CR'">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
              stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </div>
        <div *ngIf="qmsservice.moduleName=='CAPA'">
          <img class="svg_dimension" src="../../assets/img/CAPA.svg" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName=='DV'">
          <img class="svg_dimension" src="../../assets/img/Deviations.svg" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName=='AU'">
          <img lass="svg_dimension" src="../../assets/img/Audit_cr.svg" alt="" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName=='QI'">
          <img class="svg_dimension" src="../../assets/img/Quality Issues.svg" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName=='CC'">
          <img class="svg_dimension" src="../../assets/img/Customer Complaints.svg" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName=='IN'">
          <img class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
        </div>
        <div *ngIf="qmsservice.moduleName==null||qmsservice.moduleName==''">
          <img class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
        </div> &nbsp;:
        <button class="btn menu_item active border-0 outline-0 dropdown-toggle pt-2 pb-2" type="button"
          style="min-width:150px;font-size: small;" data-bs-toggle="dropdown" aria-expanded="false">
          {{defaultmoduleName}} &nbsp;
          <i class="fa-solid fa-chevron-down"></i>
        </button>
        <ul class="dropdown-menu px-3 border-0 dropdown_items" style="min-width:400px">
          <li *ngFor="let item of qmsservice.userModuleList" class="d-flex align-items-center pt-2"
            style="border-top: 1px solid #cfcfcf;">
            <div *ngIf="item.module=='CR'">
              <svg width="24" height="25" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
                  stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </div>
            <div *ngIf="item.module=='CAPA'">
              <img class="svg_dimension" src="../../assets/img/CAPA.svg" alt="" />
            </div>
            <div *ngIf="item.module=='DV'">
              <img class="svg_dimension" src="../../assets/img/Deviations.svg" alt="" />
            </div>
            <div *ngIf="item.module=='AU'">
              <img lass="svg_dimension" src="../../assets/img/Audit_cr.svg" alt="" alt="" />
            </div>
            <div *ngIf="item.module=='QI'">
              <img class="svg_dimension" src="../../assets/img/Quality Issues.svg" alt="" />
            </div>
            <div *ngIf="item.module=='CC'">
              <img class="svg_dimension" src="../../assets/img/Customer Complaints.svg" alt="" />
            </div>
            <div *ngIf="item.module=='IN'">
              <img class="svg_dimension" src="../../assets/img/investigation.png" alt="" />
            </div>
            <div *ngIf="item.module=='DA'">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g>
                  <g>
                    <path
                      d="M16.2222 1.99998C17.2041 1.99998 18 2.78502 18 3.75341L18 6.74659C18 7.71498 17.2041 8.50001 16.2222 8.50001H13.5556C12.5737 8.50001 11.7778 7.71498 11.7778 6.74659L11.7778 3.75341C11.7778 2.78502 12.5737 1.99998 13.5556 1.99998L16.2222 1.99998Z"
                      stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M3.77778 1.99998C2.79594 1.99998 2 2.78502 2 3.75341L2.00001 6.74659C2.00001 7.71498 2.79595 8.50001 3.77778 8.50001H6.44445C7.42629 8.50001 8.22223 7.71498 8.22223 6.74659L8.22222 3.75341C8.22222 2.78502 7.42628 1.99998 6.44444 1.99998L3.77778 1.99998Z"
                      stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M16.2222 11.5C17.2041 11.5 18 12.285 18 13.2534V16.2466C18 17.215 17.2041 18 16.2222 18H13.5556C12.5737 18 11.7778 17.215 11.7778 16.2466L11.7778 13.2534C11.7778 12.285 12.5737 11.5 13.5556 11.5H16.2222Z"
                      stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M3.77778 11.5C2.79594 11.5 2.00001 12.285 2.00001 13.2534L2.00001 16.2466C2.00001 17.215 2.79595 18 3.77779 18H6.44445C7.42629 18 8.22223 17.215 8.22223 16.2466L8.22223 13.2534C8.22223 12.285 7.42629 11.5 6.44445 11.5H3.77778Z"
                      stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </g>
              </svg>
            </div>
            <a class="dropdown-item px-3 dropdown_text" (click)="newmoduleSelect(item,'popupClicked')">
              {{item.moduleName}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="button-continer btn-align  align-items-center" mat-dialog-actions
      style="position: absolute; bottom: 0px; ">
      <button mat-stroked-button class="addButton" (click)="loadMainCall()">
        Ok </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelnewGrouppopupSelected()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #groupPopuup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelGroupSelected()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 20px;">
    <div class="d-flex row mt-2">
      <div class="d-flex col-md-12 group-dropdown-container">
        <div class="col-md-2">
          <label for="email">Group</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-10 group-dropdown-align">
          <ng-multiselect-dropdown style="position: absolute; width: 65%;" class="multiselect-container"
            [(ngModel)]="selectedGroupValue" [settings]="singleSelectDropdownSetting" [data]="groupValueDropdown"
            (onSelect)="onSelectedGroup($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>
    <br>
    <div class="d-flex row mt-2">
      <div class="d-flex col-md-12 group-dropdown-container">
        <div class="col-sm-2">
          <label for="email">Module</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-10 group-dropdown-align">

          <ng-multiselect-dropdown style="position: absolute;width: 65%;" class="multiselect-container"
            [(ngModel)]="tempselectedModuleName1" [settings]="singleSelectDropdownSetting1" [data]="tempuserModuleList"
            (onSelect)="onSelectedmodule($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="moduleMethod(tempselectedModuleName12=='AU'?'AU':null,true)">
      Ok </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelGroupSelected()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>


<ng-template #businessPsop>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelbusinessPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Review/Approver </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-stage-user [data]="executionDetails"></app-stage-user>
</ng-template>

<ng-template #messageHistoryPopup>
  <button class="close close-button" (click)="cancelMessageHistoryFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="message-history">
    <table style="max-height: 80vh !important;">
      <thead>
        <th style="text-align:center;">
          <span>Time</span>
        </th>
        <th style="text-align:center;">
          <span>Page Name</span>
        </th>
        <th style="text-align:center;">
          <span>Message</span>
        </th>
      </thead>
      <tbody>
        <tr class="data-row-container" *ngIf="message.message.length == 0">
          <td colspan="3" class="grid-message-container"> No data to display </td>
        </tr>
        <tr class="data-row-container border-bottom" *ngFor="let list of message.message">
          <td style="width:150px; text-align:center;">
            {{ list.dateTime }}
          </td>
          <td style="width:150px; text-align:center;">
            {{ list.pageName }}
          </td>
          <td style="text-align:left;" [ngStyle]=" {'color': (list.type=='Error' ? 'red':'green')}"
            class="row-data fontcolor">
            {{ list.message }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #uploadImagesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelUploadLogoFunction()" mat-button><i
      style="font-size: 23px;color: blue;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="d-flex row">
      <div class="d-flex col-md-12 group-dropdown-container">
        <div class="col-md-3">
          <label for="email">Group</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-9 group-dropdown-align">
          <ng-multiselect-dropdown style="position: absolute;width: 70%;" class="multiselect-container"
            [(ngModel)]="selectedGroupValue" [settings]="singleSelectDropdownSetting" [data]="groupValueDropdown"
            (onSelect)="onSelectedGroup($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>
    </div>
    <br>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="moduleMethod(qmsservice.moduleName,false)"> Ok </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelGroupSelected()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>

<ng-template #messageHistoryPopup>
  <button class="close close-button" (click)="cancelMessageHistoryFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="messageTable">
    <table>
      <th> <span>Time</span></th>
      <th> <span>PageName</span></th>
      <th> <span>Message</span></th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr class="data-row-container" *ngIf="message.message.length == 0">
        <td colspan="3" class="grid-message-container"> No data to display </td>
      </tr>
      <tr class="data-row-container border-bottom" *ngFor="let list of message.message">
        <td style="width:150px" class="btn-align">{{ list.dateTime }}</td>
        <td style="width:150px" class="btn-align">{{ list.pageName }}</td>
        <td [ngStyle]=" {'background-color': (list.type=='Error' ? 'red':'green')}" class="row-data fontcolor">{{
          list.message }}</td>
      </tr>
    </table>
  </div>
</ng-template>

<ng-template #uploadImagesPopup1>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelUploadLogoFunction()" mat-button><i
      style="font-size: 23px;color: blue;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="row">
      <div class="col-md-12" id="upload-btn-wrapper">
        <button class="btn">Choose image...</button>
        <input id="uploadInputValue" type="file" name="myfile" (change)="uploadImages($event);readURL($event)" />

        <div class="upload-val-container d-flex justify-content-center">
          <span id="logo-success-icon" class="far fa-check-circle"></span><span id="logo-success-msg">Image uploaded
            successfully</span>
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please upload
            JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            upload the image</span>
          <span *ngIf="logosizeextended">
            <span class="fas fa-exclamation-circle"></span>
            <span>File size exceeds the limit (500KB). Please choose a smaller file</span>
          </span>
        </div>
        <div *ngIf="profileImage" class="row" style="justify-content:center;">
          <img [src]="profileImage" alt="profile" style="height:150px;width:160px;" />
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="uploadButton" (click)="uploadLogoImage()">
      <i class="fas fa-upload"></i> Upload
    </button>
  </div>
</ng-template>

<ng-template #notificationPopup>
  <button class="close close-button" (click)="cancelNotificationPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Notifications</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="myTrainingLeftPlace" style="height: auto;max-height: 600px;overflow-y: auto;overflow-x: hidden;">
    <app-activity-notifications></app-activity-notifications>
  </div>
</ng-template>

<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>